import { useLocation, Navigate } from 'react-router-dom';
import { useSubscriptionCheck } from '../hooks/useSubscriptionCheck';

export function SubscriptionRouter({ children }) {
  const { isActive, loading } = useSubscriptionCheck();
  const location = useLocation();

  // Enquanto está carregando a verificação da assinatura
  if (loading) {
    return (
      // Verificando assinatura...
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg"></div>
      </div>
    );
  }

  // Se não tiver assinatura ativa → redireciona para a tela de planos
  if (!isActive) {
    return <Navigate to="/subscription-management-screen" state={{ from: location }} replace />;
  }

  // Tudo certo → libera o conteúdo da rota
  return <>{children}</>;
}